import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import mask from '@alpinejs/mask';
import morph from '@alpinejs/morph';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';
import Iodine from '@caneara/iodine';
import "lazysizes";

import { default as Common } from './modules/common.js';
import { default as Dropdowns } from './modules/dropdowns.js';
import { default as Forms } from './modules/forms.js';
import { default as Sliders } from './modules/sliders.js';
import { default as Zoom } from './modules/zoom.js';

const modules = {
  Common,
  Dropdowns,
  Forms,
  Sliders,
  Zoom,
};

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(mask);
Alpine.plugin(morph);
window.Alpine = Alpine;
Alpine.start();
